/* eslint jsx-a11y/aria-role: 0 */
import React, { Component } from 'react';
import { isAddressBarOpened } from '../../reducers/addressReducer';
import { connect } from 'react-redux';
import { isMainPage } from "../../helpers/urlParts";
import {
  isPaymentKiosk as isPaymentKioskSelector
} from '../../selectors/configSelectors';

class TreezLogo extends Component {
  isEnabled() {
    const {isAddressBarOpened, router, isPaymentKiosk} = this.props;
    if (isPaymentKiosk) {
      return true;
    }
    if (isMainPage(router.location.pathname)) {
      return true;
    }
    if (router.location.pathname.indexOf('category') > -1 && !isAddressBarOpened) {
      return true;
    }
    return false;
  }
  render() {
    return (
      <div style={{display : this.isEnabled() ? 'block' : 'none' }}>
          <img className="treez-icon treez-lg"  src={`${process.env.PUBLIC_URL}/assets/img/treez-lg.png`} />
          <img className="treez-icon treez-sm"  src={`${process.env.PUBLIC_URL}/assets/img/treez-sm.png`} />
     </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    isAddressBarOpened: isAddressBarOpened(state),
    router: state.router,
    isPaymentKiosk: isPaymentKioskSelector(state)
  };
};

export default connect(mapStateToProps, {})(TreezLogo);


// WEBPACK FOOTER //
// ./src/components/TreezLogo/TreezLogo.jsx